/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AxiosError } from "axios";

import axios from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 5 * 60 * 1000, // 5 min.
  headers: { Accept: "application/json" },
  timeoutErrorMessage: "Servidor não respondeu",
  adapter: ["fetch"],
});

api.interceptors.request.use(
  function (config) {
    const storedToken = localStorage.getItem("token");
    const token = storedToken?.startsWith("Bearer") ? storedToken : null;
    if (token) config.headers["Authorization"] = token;
    return config;
  },
  function (error: any) {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(undefined, (error: AxiosError<any, any>) => {
  if (import.meta.env.DEV) {
    console.log(
      error,
      error?.response?.data,
      error.config?.data,
      error.config?.url
    );
  }
  const isQueryAuthError =
    error.config?.method === "GET" && error.response?.status === 401;
  if (isQueryAuthError) {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/entrar";
    return;
  }

  return Promise.reject(error);
});

function isApiError(error: unknown): error is AxiosError<any, any> {
  return axios.isAxiosError(error);
}

function parseApiError(error: AxiosError<any, any>) {
  const responseData = error.response?.data;
  const statusMessage = responseData?.status?.message;
  if (statusMessage) return statusMessage;
  const errorMessage = responseData?.error;
  if (errorMessage) return errorMessage;
  if (error.response?.status === 503) return "Serviço fora do ar";
  if (error.response?.data)
    return (
      error.response.data?.message ||
      `Erro do servidor (${error.response.status})`
    );
  if (error.message === "Network Error") return "Erro de conexão";
  return "Erro na solicitação";
}

export function parseError(error: Error) {
  if (isApiError(error)) return parseApiError(error);
  return error.message;
}

export function isAuthError(error: Error) {
  if (!isApiError(error)) return false;
  return error.response?.status === 401;
}
